import { InjectionToken } from "@angular/core";
import { IAuthenticationGuard } from "./i-authentication.guard";

export const authenticationGuardInjectionToken: InjectionToken<IAuthenticationGuard> = new InjectionToken<IAuthenticationGuard>("digital-signage-user-dashboard-web.AuthenticationGuard");
